/*eslint no-use-before-define:0 *///TODO REMOVE THIS
/*global FileList */
var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
var Modal = require('ES/widgets/Modal');
var radio = require('ES/lib/radio');
var esUtils = require('ES/utils/esUtils');
var Constants = require('../../../../../utils/Constants');
var FormMixin = require('ES/widgets/forms/FormMixin');
var ErrorAlert = require('ES/widgets/ErrorAlert');
var RadioMixin = require('ES/utils/RadioMixin');
var ProgressBar = require('ES/widgets/ProgressBar');
var HorizontalFields = require('ES/widgets/HorizontalFields');
var UPLOAD_FILE_NAME_ARRAY = Constants.FileStore_UPLOAD_FILE_NAME + '[]';

module.exports = dd.createClass({
  mixins: [RadioMixin],
  getInitialState: function () {
    return {uploading: false, upload_progress: -1, error_msg: null};
  },
  componentWillMount: function () {
    var self = this;
    self.radio = {
      StoredFile_save: function (eid, fileid) {
        if (self.__isThisMe(eid, fileid)) {
          self.setState({uploading: true, upload_progress: -1, error_msg: null});
        }
      },
      StoredFile_save_progress: function (eid, fileid, percent) {
        if (self.__isThisMe(eid, fileid)) {
          self.setState({upload_progress: percent});
        }
      },
      StoredFile_save_succeeded: function (eid, fileid, storedfiles) {
        if (self.__isThisMe(eid, fileid)) {
          self.setState({uploading: false, upload_progress: -1, error_msg: null});
          self.props.onClose();
        }
      },
      StoredFile_save_failed: function (eid, fileid, message) {
        if (self.__isThisMe(eid, fileid)) {
          self.setState({uploading: false, upload_progress: -1, error_msg: 'Failed to upload file: ' + message});
        }
      }
    };
  },
  __isThisMe: function (eid, fileid) {
    return (eid === (this.props.event ? this.props.event.eid : -1)) && (fileid === (this.props.file_id > 0 ? this.props.file_id : -1));//don't reference __getFileFromProps b/c that file will be nuked on updates
  },
  __getFileFromProps() {
    let {event, file_id, Displaylists} = this.props;
    if (event) {
      return _.find(event.storedfiles, function (storedfile) {
        return storedfile.id === file_id;
      });
    }
    return esUtils.getIn(Displaylists, ["speaker_shared", "templatefiles", file_id]);
  },
  __onSubmit: function (data) {
    var file = this.__getFileFromProps();
    var event = this.props.event;
    var sids_to_apply_to = this.props.sids_to_apply_to;
    radio('StoredFile_save').broadcast(
      event ? event.eid : -1,
      file ? file.id : -1,
      data.description,
      data[UPLOAD_FILE_NAME_ARRAY] ? data[UPLOAD_FILE_NAME_ARRAY] : null,
      sids_to_apply_to
    );
  },
  render: function () {
    if (this.state.uploading) {
      return Modal({
          title: 'Uploading...',
          buttons: [],
          onClose: null
        },
        ProgressBar({percent: this.state.upload_progress})
      );
    }
    var event = this.props.event;
    var file = this.__getFileFromProps();
    return Modal({
        title: event ? (file ? 'Edit Attached File' : 'Attach file to event') : (file ? 'Edit Template File' : 'Upload new Template'),
        buttons: [],
        onClose: this.props.onClose
      },
      ErrorAlert({message: this.state.error_msg}),
      DaForm({
        file: file,
        event: event,
        file_id: this.props.file_id,
        onClose: this.props.onClose,
        onSubmit: this.__onSubmit,
        Displaylists: this.props.Displaylists
      })
    );
  }
});

var DaForm = dd.createClass({
  mixins: [FormMixin],
  getInitialState: function () {
    return {clicked_edit_file: false};
  },
  getInitialValuesSourceVersion: function (props) {
    return (props.event ? esUtils.getEventVersionIdentifier(props.event) : -1) + '_' + props.file_id;
  },
  getInitialValues: function (props) {
    var file = props.file;
    if (!file) {
      return null;
    }
    return {
      description: file.description,
      filename: file.originalfilename,
      uploaded: file.uploadedby + ' - ' + esUtils.format_date(file.postdate, 'mm/dd/yyyy')
    };
  },
  buildFields: function () {
    var clicked_edit_file = !!this.state.clicked_edit_file;
    var file = this.props.file;
    var schema = {
      description: {
        label: 'Description',
        type: 'text',
        validate: function (v) {
          return true;
        }
      }
    };
    if (file && !clicked_edit_file) {
      schema.filename = {
        label: 'File',
        type: 'static'
      };
      schema.uploaded = {
        label: 'Uploaded by',
        type: 'static'
      };
    } else {
      schema[UPLOAD_FILE_NAME_ARRAY] = {
        label: 'File',
        type: 'file',
        multiple: true
      };
    }
    return schema;
  },
  onFormChanged: function (field_path, new_value) {
    if (field_path === UPLOAD_FILE_NAME_ARRAY && new_value instanceof FileList) {
      if (new_value.length > 1) {
        this._form_onChange('description', '');
      } else {
        var file = new_value[0];
        var data = this.state.data || {};
        if (_.isEmpty(data.description)) {
          var parts = /^(.*)\.[0-9a-z]+$/i.exec(file.name);
          this._form_onChange('description', ((parts && parts[1]) || file.name).replace(/_/g, ' '));
        }
      }
    }
  },
  __clickViewAndEdit: function (e) {
    //NOTE we DO want it do do the default aka follow the link
    this.setState({clicked_edit_file: true});
  },
  render: function () {
    var file = this.props.file;
    var data = this.state.data || {};
    var event = this.props.event;
    var fields = this.buildFields();
    var errors = this.state.errors || {};
    var onClose = this.props.onClose;
    var clicked_edit_file = !!this.state.clicked_edit_file;

    var self = this;
    return dd.form({className: 'form-horizontal', onSubmit: this._form_onSubmit},
      HorizontalFields({
        fields: fields,
        errors: errors,
        buildInput: function (field, name) {
          if (name === 'filename') {
            return dd.div({className: 'form-control-static'}, data.filename, ' ', dd.a({href: file.url, target: '_blank', onClick: self.__clickViewAndEdit}, 'Edit file'));
          } else if (name === UPLOAD_FILE_NAME_ARRAY && clicked_edit_file) {
            return dd.div({style: {marginTop: 6}},
              'After saving changes, click CHOOSE FILE below, select the changed file ("' + _.first(_.last(file.url.split('/')).split('?')) + '"), and click SAVE.',
              self._form_buildInput(field, name)
            );
          }
          return self._form_buildInput(field, name);
        },
        label_size: 2
      }),
      dd.div({className: 'form-group'},
        dd.div({className: 'col-sm-10 col-sm-offset-2', style: {paddingLeft: '25px'}},
          dd.small({className: 'text-muted'}, 'To select multiple files, hold down the CTRL or SHIFT key while selecting.', dd.br(), 'If you select multiple files, the description field will be ignored.')
        )
      ),
      HorizontalFields.FormButtons({label_size: 2, scale: 'md', submit_btn_text: file ? 'Save' : (event ? 'Attach' : 'Upload'), onCancel: onClose, right_align_buttons: true})
    );
  }
});


// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/library/StoredFileModal.js